module.exports = __webpack_public_path__ + "static/sohomalight-4cb87d7606d64f1c6abdd4743ebf0e38.woff2";